import React from 'react'
import '../assets/css/style.css';
import '../style/HomeScreen.css'
const ContactUsUI = () => { return ( 
    <div className="amg-floating-contacts">
        <div className="amg-floating-contact-wrap">
          <div className="amg-floating-icon" title="ഞങ്ങളുമായി ബന്ധപ്പെടുക">
            <i className="ri-customer-service-2-line"></i>
          </div>
          <div className="amg-floating-link">
            <div className="row">
              

              <div className="col-md-12">
                <div>
                  <h6>RBI റീട്ടെയിൽ ഡയറക്റ്റ് സപ്പോർട്ട്  </h6>
                  <p>
                    <i className="ri-phone-line"></i>
                    <i class="ri-arrow-right-up-line" style={{color: 'limegreen', marginLeft: '-4px'}}></i>
                    <a href="tel:1800 267  7955" title="Out-Bound Number">1800 267 7955</a>
                  </p>
                  <p>
                    <i class="ri-phone-line"></i>
                    <i class="ri-arrow-left-down-line" style={{color: 'red' , marginLeft:'-4px'}}></i>
                    <a href="+tel:91-22-61546335" title="In-Bound Number">+91-22-61546335</a>
                  </p>
                  <p>
                    <i className="ri-mail-line"></i>
                    <a href="ഇതിലേക്ക് മെയിൽ ചെയ്യുക:support@rbiretaildirect.org.in">
                      support@rbiretaildirect.org.in
                    </a>
                  </p>
                  <p>
                    <i className="ri-time-line"></i>
                    <a style={{ color: "#000" }}>10am - 6pm (തിങ്കൾ - ശനി)</a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
       ) };export default ContactUsUI  
